import React from 'react';
import { Nav, Navbar } from 'rsuite';
import { Dropdown, Icon } from 'semantic-ui-react';
import { useHistory } from 'react-router-dom';
import { getUser, delToken } from "../../services/auth";

import './styles.css';


export default function Navbarr(props) {
    const history = useHistory();
    const user = getUser();
    const value = 0;
    const valueMenu = -1;

    const click = (e, {value}) => {
        if (value === 2) {
            delToken();
            history.replace('/');
        }
    }

    const clickMenu = (e, {value}) => {
        switch (value) {
            case 1:
                history.push('/users');
                break;
            case 2:
                history.push('/users/new');
                break;
            case 3:
                history.push('/stores');
                break;
            case 4:
                history.push('/stores/new');
                break;
            case 5:
                history.push('/routes');
                break;
            case 6:
                history.push('/routes/new');
                break;
            case 7:
                history.push('/products');
                break;
            case 8:
                history.push('/products/new');
                break;
            case 9:
                history.push('/competitors');
                break;
            case 10:
                history.push('/competitors/new');
                break;
            case 11:
                history.push('/visits');
                break;
            case 12:
                history.push('/map');
                break;

            default:
                break;
        }
    }

    const trigger = (
        <span>
            <Icon name='user' /> {user}
        </span>
    )

    const options = [
        { key: 'profile', text: 'Conta',  value: 1, icon: 'user'},
        { key: 'sign-out', text: 'Sign Out', value: 2, icon: 'sign out' },
    ]


    const triggerMenu = (
        <span>
            <Icon name='bars' /> Menu
        </span>
    )

    const menuOptions = [
        { key: 'user-list', text: 'Listar usuários', value: 1 },
        { key: 'user-new', text: 'Cadastrar usuário', value: 2 },
        { key: 'store-list', text: 'Listar lojas', value: 3 },
        { key: 'store-new', text: 'Cadastrar loja', value: 4 },
        { key: 'route-list', text: 'Listar rotas', value: 5 },
        { key: 'route-new', text: 'Cadastrar rota', value: 6 },
        { key: 'product-list', text: 'Listar produto', value: 7 },
        { key: 'product-new', text: 'Cadastrar produto', value: 8 },
        { key: 'compet-list', text: 'Listar competidores', value: 9 },
        { key: 'compet-new', text: 'Cadastrar competidor', value: 10 },
        { key: 'visit-list', text: 'Listar visitas', value: 11 },
        { key: 'map', text: 'Mapa', value: 12 }
        
    ]

    return (
        <div>
        <Navbar style={{backgroundColor: '#fff', fontSize: '10px'}}>
            {/*<Navbar.Header>
            <a href="/" className="navbar-brand logo">RSUITE</a>
            </Navbar.Header>*/}
            <Navbar.Body >
            <Nav>
                <div className="mobile-menu">
                    <Dropdown
                        trigger={triggerMenu}
                        options={menuOptions}
                        value={valueMenu}
                        onChange={clickMenu}
                        pointing='top left'
                        icon={null} 
                        />
                </div>
            </Nav>
            <Nav style={{marginRight: '20px', height: '56px'}} pullRight >
                <Dropdown
                    style={{marginTop: '20px'}}
                    trigger={trigger}
                    options={options}
                    value={value}
                    onChange={click}
                    pointing='top left'
                    />
            </Nav>
            </Navbar.Body>
        </Navbar>
        <hr className="hr-style" />
        </div>
    );
}
